import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import GoogleAnalytics from './components/GoogleAnalytics';
import Home from './pages/Home';
import AboutPage from './pages/About';
import ServicesPage from './pages/Services';
import ProcessPage from './pages/Process';
import ProjectsPage from './pages/Projects';
import ContactPage from './pages/Contact';
import './styles/global.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <GoogleAnalytics measurementId={process.env.REACT_APP_GA_MEASUREMENT_ID} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App; 